import { useWallet } from "@manahippo/aptos-wallet-adapter";
import TablePagination from "@mui/material/TablePagination";
import { useEffect, useState, MouseEvent, ChangeEvent } from "react";

import Button from "../../components/Common/Button";
// import SearchInput from "../../components/SearchInput";
import SelectNftBox from "../../components/Common/SelectNftBox";
import TransactionDialog from "../../components/Common/TransactionDialog";
import { get_pool_votes, getTransactionByHash } from "../../libs/aptos_sdk";
import { MyPoolVote, MyRewardInfo } from "../../libs/pool";
import { get_coin_icon, bribe_claim } from "../../libs/swap_sdk";
import { sleep } from "../../utils/common";

export default function Rewards() {
  const { signAndSubmitTransaction, account } = useWallet();
  const [txn, setTxn] = useState<string>("");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [step, setStep] = useState<number>(0);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tokenId, setTokenId] = useState<number>(0);
  const [poolVoteList, setPoolVoteList] = useState<MyPoolVote[]>([]);

  useEffect(() => {
    const fetch = async () => {
      if (tokenId === 0) return;
      const poolVotes = await get_pool_votes(tokenId);
      setPoolVoteList(poolVotes);
    };
    if (tokenId !== 0) {
      fetch();
    } else {
      setPoolVoteList([]);
    }
  }, [tokenId]);

  const handleChangePage = (
    event: MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handle_claim = async (bribe_id: number, rewards: MyRewardInfo[]) => {
    if (!account || !account.address || tokenId === 0) return;
    if (rewards.length === 0) return;
    setTxn("");
    setOpenAlert(true);
    setStep(0);

    const data = await bribe_claim(
      signAndSubmitTransaction,
      tokenId,
      bribe_id,
      rewards
    );

    setTxn(data.hash);
    setStep(1);
    let transaction;
    while (!transaction) {
      try {
        transaction = await getTransactionByHash(data.hash);
      } catch {
        await sleep(500);
      }
    }
    setStep(2);
  };

  const handleCloseAlert = () => setOpenAlert(false);

  return (
    <div className="h-screen overflow-y-auto">
      <div className="min-h-screen flex pt-16 pb-4">
        <div className="flex flex-col w-full gap-8 p-10 max-md:p-5">
          <div className="flex justify-between items-center gap-4">
            <div className="flex w-2/4">
              <SelectNftBox setTokenId={setTokenId} />
            </div>
            {/* <Button className="w-fit shrink-0">Claim All</Button> */}
          </div>

          <div className="bg-white rounded-lg bg-opacity-10">
            <div className="w-full max-w-full overflow-x-scroll">
              <div className="w-full max-xl:w-[1000px]">
                <table className="w-full">
                  <thead className="bg-white bg-opacity-10 text-white w-full mb-3">
                    <tr>
                      <th className="py-3 pl-3 w-[25%] text-left">Pool</th>
                      <th className="text-right">Your Position</th>
                      <th className="text-right">You Earned</th>
                      <th className="w-[20%] text-right pr-3">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(rowsPerPage > 0
                      ? poolVoteList.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : poolVoteList
                    ).map((item: MyPoolVote, index: number) => {
                      return (
                        <tr
                          className="overflow-X-scroll"
                          key={`pool_vote_key_${index}`}
                        >
                          <td className="flex pl-3 py-2 gap-5">
                            <div className="flex justify-center items-center ">
                              <img
                                alt="Coin"
                                className="w-10 h-10"
                                src={
                                  get_coin_icon(item.pool.x_coin_info.address)
                                    .icon
                                }
                              />
                              <img
                                alt="Coin"
                                className="w-10 h-10 -ml-4"
                                src={
                                  get_coin_icon(item.pool.y_coin_info.address)
                                    .icon
                                }
                              />
                            </div>
                            <div className="flex justify-center items-center">
                              <p className="font-semibold text-white">{`${item.pool.x_coin_info.symbol}-${item.pool.y_coin_info.symbol}`}</p>
                            </div>
                          </td>
                          <td className="text-right">
                            <div className="flex-col justify-end text-white">
                              {item.rewards.map((reward_coininfo) => (
                                <p> {reward_coininfo.coin_info.symbol}</p>
                              ))}
                            </div>
                          </td>
                          <td className="text-right">
                            <div className="flex-col justify-end text-white">
                              {item.rewards.map((reward_coininfo) => (
                                <p>
                                  {" "}
                                  {(
                                    reward_coininfo.reward /
                                    Math.pow(
                                      10,
                                      reward_coininfo.coin_info.decimals
                                    )
                                  ).toFixed(3)}{" "}
                                  {reward_coininfo.coin_info.symbol}
                                </p>
                              ))}
                            </div>
                          </td>
                          <td>
                            <div className="flex justify-end pr-2 pt-1">
                              <Button
                                variant="gradient"
                                className="w-32"
                                onClick={() => {
                                  handle_claim(item.bribe_id, item.rewards);
                                }}
                              >
                                Claim
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="w-full pr-3 sm:pr-0 flex justify-end max-xl:justify-start items-center">
              <TablePagination
                className="pagination"
                component="div"
                count={poolVoteList.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        <TransactionDialog
          openAlert={openAlert}
          txn={txn}
          title="Reward"
          step={step}
          handleCloseAlert={handleCloseAlert}
        />
      </div>
    </div>
  );
}
